import React, { Component } from 'react';
import Formulario from './tipoObraForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class TipoObra extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leerTipoObra, getModulo } = this.props;
        const id = match.params.id;
        
        if (id){
            this.setState({crear: false});
            leerTipoObra(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
    }
    
    render(){
        const { registroTipoObra, modificarTipoObra, loader, modulo } = this.props;
        const { crear } = this.state;
        const funcionEnvio = crear ? registroTipoObra : modificarTipoObra;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {funcionEnvio}
                    crear = {crear}
                    modulo = {modulo}
                />
            </LoadMask>
        );
    }
}

export default TipoObra;
